<app-loading-page [isLoading]="false" [isProcessing]="true"></app-loading-page>
